import { cUtil }                  from "../../functions/util";
import { cOrderListOverviewItem } from "./order-list-overview-item";

export class cOrderListOverview {

  div_titleArea = document.querySelector('.c-page-header div:nth-child(2)') as HTMLElement ;
  h1_title      = document.createElement('h1');
  p_list        = document.createElement('p');
  a_export      = document.createElement('a');
  form          = document.querySelector('.c-order-list-overview')        as HTMLFormElement;
  script        = document.querySelector('.c-order-list-overview script') as HTMLScriptElement;

  lists : cOrderListOverviewItem[] = [];

  constructor() {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const json: OrderListOverview = JSON.parse(this.script.innerText);

    // ---- Structure ----
    this.div_titleArea.append(this.h1_title);
    this.form.append(this.a_export);

    for(const list of json.lists) {
      const listObj = new cOrderListOverviewItem(list, this.form, json.nonce);
      this.lists.push(listObj);
    }

    if (json.lists.length === 0) {
      this.form.append(this.p_list);
    }

    // ---- Classes ----
    this.a_export.classList.add('c-button-light');
    this.p_list.classList.add('c-info');

    // ---- Texts -----
    this.h1_title.innerText = __('Bestelllisten', 'custom');
    this.a_export.innerText = __('Drucken', 'custom');
    this.p_list.innerText   = __('Es sind keine Listen vorhanden.', 'custom');

    // ---- Other ----
    this.a_export.href      = cUtil.urlP('/c-order-list-overeview-pdf');
    this.a_export.target    = '_blank';
 
  }
}